module.exports = __webpack_public_path__ + "static/media/IMG_0384.738320ed.JPG";